import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { classNames } from '@/ui/utils/main'

export const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(({ className, ...props }, fwdRef) => (
  <LabelPrimitive.Root
    ref={fwdRef}
    className={classNames(
      'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName
